import { useMemo } from 'react';

import type { PlacementDetailsWorkRestriction } from 'src/store/placementDetailsPageSlice/types';
import {
  type PreSelectedTask,
  type RestrictionListParentTask,
  type RestrictionListTask,
  setupPreselectedRestrictionListItems,
  validateIncomingPreSelectedRestrictionItems,
} from 'src/utils/restrictionUtilsLegacy';

export const useRestrictionValidation = (
  consolidatedRegionTasks: (RestrictionListTask | RestrictionListParentTask)[] = [],
  workRestrictions: PlacementDetailsWorkRestriction[] = [],
  modifiedShiftLength: number = 0,
) => {
  // Memoize the selectedTasks transformation
  const selectedTasks = useMemo(() => {
    if (!workRestrictions?.length) {
      return [];
    }

    return workRestrictions.map((restriction) => ({
      taskId: restriction.taskId,
      label: restriction.taskName,
      restrictedValue: restriction.restrictedValue,
      measureUnit: restriction.measureUnit,
      bodyLocationValue: restriction.bodyLocation,
    })) as PreSelectedTask[];
  }, [workRestrictions]);

  const doesPlacementHaveRestrictionErrors = useMemo(() => {
    if (!consolidatedRegionTasks.length || !selectedTasks.length) {
      return false;
    }

    const preSelectedRestrictionItems = setupPreselectedRestrictionListItems(selectedTasks, consolidatedRegionTasks);
    const isValid = validateIncomingPreSelectedRestrictionItems(preSelectedRestrictionItems, modifiedShiftLength);

    const result = !isValid;
    return result;
  }, [consolidatedRegionTasks, selectedTasks, modifiedShiftLength]);

  return doesPlacementHaveRestrictionErrors;
};
